var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.GameScene = function() {
    EHDI.aka.Container.call(this);
    // this.scoreDisplay = EHDI.components.ScoreManager(this);
    // this.pauseButton = new EHDI.components.pauseButton();
    // this.timer = new EHDI.components.Timer();
    // this.timer.timeLeft = 120;
    // this.elapseTime = 0;
    // this.isOver = false;
    // this.timeIsUp = false;
    // this.harvestCount = 0;

    // this.bg = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_gamebg"]);
    // this.addChild(this.bg);

    // this.crops = [[],[],[],[]];
    // this.selectedCrops = [];

    // this.bindedUpdate = this.update.bind(this);
    // this.isCropFailed = false;

    // var startX = EHDI.GAME.sceneManager.getStageWidth() * 0.082;
    // var startY = EHDI.GAME.sceneManager.getStageHeight() * 0.1933;
    // for(var y = 0, l = this.crops.length; y < l; y++){
    //     for( var x = 0; x < 8; x++){
    //         var c = new EHDI.components.Crop();
    //         c.x = startX + c.width * x;
    //         c.y = startY + c.height * y;
    //         this.crops[y].push(c);
    //         this.addChild(c);
    //     }
    // }
    // this.timer.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.294, EHDI.GAME.sceneManager.getStageHeight() * 0.033);
    
    // this.scoreDisplay = EHDI.components.ScoreManager(this);
    // this.scoreDisplay.setXY(EHDI.GAME.sceneManager.getStageWidth() * 0.02, EHDI.GAME.sceneManager.getStageHeight() * 0.033);

    // this.addChild(this.timer);
    // this.addChild(this.pauseButton);

    // this.bindedMouseDown = this.ontouchdown.bind(this);
    // this.bindedMouseMove = this.ontouchmove.bind(this);
    // this.bindedMouseUp = this.ontouchup.bind(this);

    // this.mousedown = this.touchstart = this.bindedMouseDown;
    // this.mouseup = this.touchend = this.bindedMouseUp;
    // this.mouseupoutside = this.touchendoutside = this.bindedMouseUp;

    // this.curTouchID = null;
    // this.isEndingTurn = false;

    // var matches = EHDI.utils.CropUtils.getCropsWithMatches(this.crops);
    // while(matches.length == 0) {
    //     this.growCrops(false, false);
    //     matches = EHDI.utils.CropUtils.getCropsWithMatches(this.crops);
    // }

    // this.timer.setTimerDoneCallback(this.timerOver.bind(this));

    
    // this.scoreEffects = new EHDI.components.ScoreEffectManager();
    // this.scoreEffects.init(this);

    
    // EHDI.gameInstanceRef = this;
}

EHDI.scene.GameScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.GameScene.prototype.initProps = function() {
    this.curTouchID = null;
    this.isEndingTurn = false;
    this.elapseTime = 0;
    this.isOver = false;
    this.timeIsUp = false;
    this.harvestCount = 0;
    EHDI.gameInstanceRef = this;
}

EHDI.scene.GameScene.prototype.initGraphics = function() {
    
    this.scoreDisplay = EHDI.components.ScoreManager(this);
    this.pauseButton = new EHDI.components.pauseButton();
    this.timer = new EHDI.components.Timer();
    this.timer.timeLeft = 120;
    this.elapseTime = 0;
    this.isOver = false;
    this.timeIsUp = false;
    this.harvestCount = 0;

    this.bg = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_gamebg"]);
    this.addChild(this.bg);

    this.crops = [[],[],[],[]];
    this.selectedCrops = [];

    this.bindedUpdate = this.update.bind(this);
    this.isCropFailed = false;

    var startX = EHDI.GAME.sceneManager.getStageWidth() * 0.082;
    var startY = EHDI.GAME.sceneManager.getStageHeight() * 0.1933;
    for(var y = 0, l = this.crops.length; y < l; y++){
        for( var x = 0; x < 8; x++){
            var c = new EHDI.components.Crop();
            c.x = startX + c.width * x;
            c.y = startY + c.height * y;
            this.crops[y].push(c);
            this.addChild(c);
        }
    }
    this.timer.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.294, EHDI.GAME.sceneManager.getStageHeight() * 0.033);
    
    this.scoreDisplay = EHDI.components.ScoreManager(this);
    this.scoreDisplay.setXY(EHDI.GAME.sceneManager.getStageWidth() * 0.02, EHDI.GAME.sceneManager.getStageHeight() * 0.033);

     this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
      this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.95, EHDI.GAME.sceneManager.getStageHeight() * 0.075);
      this.closeBtn.setOnClickFunction(function(){
        callFlexFunction()
      });
     

    this.addChild(this.timer);
    this.addChild(this.pauseButton);
    this.addChild(this.closeBtn);

    this.bindedMouseDown = this.ontouchdown.bind(this);
    this.bindedMouseMove = this.ontouchmove.bind(this);
    this.bindedMouseUp = this.ontouchup.bind(this);

    this.mousedown = this.touchstart = this.bindedMouseDown;
    this.mouseup = this.touchend = this.bindedMouseUp;
    this.mouseupoutside = this.touchendoutside = this.bindedMouseUp;

    this.curTouchID = null;
    this.isEndingTurn = false;

    var matches = EHDI.utils.CropUtils.getCropsWithMatches(this.crops);
    while(matches.length == 0) {
        this.growCrops(false, false);
        matches = EHDI.utils.CropUtils.getCropsWithMatches(this.crops);
    }

    this.timer.setTimerDoneCallback(this.timerOver.bind(this));

    
    this.scoreEffects = new EHDI.components.ScoreEffectManager();
    this.scoreEffects.init(this);

    
    EHDI.gameInstanceRef = this;
}

EHDI.scene.GameScene.prototype.initListeners = function() {
    this.bindedMouseDown = this.ontouchdown.bind(this);
    this.bindedMouseMove = this.ontouchmove.bind(this);
    this.bindedMouseUp = this.ontouchup.bind(this);

    this.mousedown = this.touchstart = this.bindedMouseDown;
    this.mouseup = this.touchend = this.bindedMouseUp;
    this.mouseupoutside = this.touchendoutside = this.bindedMouseUp; 
}

EHDI.scene.GameScene.prototype.killProps = function() {
    // EHDI.GAME.updateManager.removeFrameListener(this.timer.timerUpdate);
    this.interactive = false;
    this.mousemove = this.touchmove = null;
    this.curTouchID = null;
    this.isEndingTurn = null;
    this.elapseTime = null;
    this.isOver = null;
    this.timeIsUp = null;
    this.harvestCount = null;
}

EHDI.scene.GameScene.prototype.killGraphics = function() {
    if(this.scoreEffects != null)
    {
        this.scoreEffects.dispose();
        delete this.scoreEffects;
    }


    if(this.bg != null)
    {
        this.removeChild(this.bg);
        this.bg.destroy({children: true});
    }
    delete this.bg;

    if(this.selectedCrops != null)
    {
        for(let i = 0; i< this.selectedCrops.length; i++)
        {
            let crop = this.selectedCrops.pop();

            crop.destroy({children: true});
            delete crop;
        }
    }
    delete this.selectedCrops;

    if(this.crops != null)
    {
        for(let i = 0; i< this.crops.length; i++)
        {
            let cropRow = this.crops.pop();
            for(let j = 0; j< cropRow.length; j++)
            {
                let crop = cropRow.pop();

                crop.destroy({children: true});
                delete crop;
            }
            delete cropRow;
        }
    }
    delete this.crops;

    if(this.timer != null)
    {
        this.removeChild(this.timer);
        this.timer.dispose();
    }
    delete this.timer;

    if(this.pauseButton != null)
    {
        this.removeChild(this.pauseButton);
        this.pauseButton.dispose();
    }
    delete this.pauseButton;

    if(this.closeBtn != null)
        {
            this.removeChild(this.closeBtn);
            this.closeBtn.dispose();
        }
    delete this.closeBtn;

    if(this.scoreDisplay != null)
    {   
        this.scoreDisplay.dispose();
    }
    delete this.scoreDisplay;

}

EHDI.scene.GameScene.prototype.killListeners= function() {

    delete this.mouseup;
    delete this.mousedown;
    delete this.mouseupoutside;
    delete this.bindedMouseDown;
    delete this.bindedMouseMove;
    delete this.bindedMouseUp;
}

EHDI.scene.GameScene.prototype.replay = function() {
    this.killListeners();
    this.killGraphics();
    this.killProps();

    this.initProps();
    this.initGraphics();
    this.initListeners();
    this.interactive = true;
}

EHDI.scene.GameScene.prototype.screenWillAppear = function() {
    this.initProps();
    this.initGraphics();
    this.initListeners();
}

EHDI.scene.GameScene.prototype.screenDidAppear = function() {
    // EHDI.GAME.updateManager.addFrameListener(this.timer.timerUpdate);
    

    this.interactive = true;

    if ( EHDI.GAME.saveData.isFirstTimePlay )
    {    
        EHDI.GAME.saveData.isFirstTimePlay = false;    
        EHDI.GAME.storageManager.setLocalInfo( EHDI.GAME.id, EHDI.GAME.saveData );
        /* EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
            console.log("data saved.");
        }); */
        EHDI.GAME.pauseButton.isPaused = true;
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
    }
};

EHDI.scene.GameScene.prototype.screenDidDisappear = function() {
    this.killListeners();
    this.killGraphics();
    this.killProps();

    this.destroy({children: true});
    delete this;
};

EHDI.scene.GameScene.prototype.popUpWillAppear = function() {
    if(this.isCropFailed) return;
    if(this.isEndingTurn){
        EHDI.DBoneFactory.enableClock = false;
        EHDI.GAME.updateManager.removeFrameListener(this.bindedUpdate);
    }
    else{
        // EHDI.GAME.updateManager.removeFrameListener(this.timer.timerUpdate);
        this.interactive = false;
        this.curTouchID = null;
        this.mousemove = this.touchmove = null;
    }
};

EHDI.scene.GameScene.prototype.popUpDidDisappear = function() {
    if(this.isCropFailed) return;
    if(this.isEndingTurn){
        EHDI.DBoneFactory.enableClock = true;
        EHDI.GAME.updateManager.addFrameListener(this.bindedUpdate);
    }
    else{
        // EHDI.GAME.updateManager.addFrameListener(this.timer.timerUpdate);
        this.interactive = true;
    }
};

EHDI.scene.GameScene.prototype.update = function(dt){
    this.elapseTime += dt;
    if(this.elapseTime >= 600 ) {
        EHDI.GAME.updateManager.removeFrameListener(this.bindedUpdate);
        this.elapseTime = 0;
        matches = EHDI.utils.CropUtils.getCropsWithMatches(this.crops);
        if(matches.length == 0) this.endTurn(false);
        else {
            while(this.selectedCrops.length > 0) this.selectedCrops.pop();
            this.isEndingTurn = false;
            this.interactive = true;
        }
    }
        
    if(this.scoreEffects != null) this.scoreEffects.update(dt);
}

EHDI.scene.GameScene.prototype.growCrops = function(growGreen, play){
    for(var i = 0, l = this.crops.length; i < l; i++){
        for(var j = 0, jl = this.crops[i].length; j < jl; j++){
            if(this.selectedCrops == null || this.selectedCrops.indexOf(this.crops[i][j]) == -1){

                if(play)
                    this.crops[i][j].disableGlow();

                if((this.crops[i][j].cropState == EHDI.components.CropState.GROWN && growGreen) ||
                    this.crops[i][j].cropState != EHDI.components.CropState.GROWN){
                    var rand = Math.random();
                    if(rand >= 0.4) this.crops[i][j].updateGrowth(play);
                }
            }
        }
    }
}

EHDI.scene.GameScene.prototype.endTurn = function(growGreen) {
    this.isEndingTurn = true;
    this.growCrops(growGreen, true);
    if(!EHDI.GAME.updateManager.hasFrameListener(this.bindedUpdate))
        EHDI.GAME.updateManager.addFrameListener(this.bindedUpdate);
};

EHDI.scene.GameScene.prototype.ontouchdown = function(e){
    if(this.curTouchID !=  null) return;
    this.curTouchID = e.data.identifier;
    var crop = EHDI.utils.CropUtils.getCropInLoc(this.crops, e.data.global);
    if(crop != null) {
        if(crop.cropState == EHDI.components.CropState.GROWN){
            crop.setSelected(true);
            this.selectedCrops.push(crop);
        }
        else{
            //game over
            this.gameOver(crop);
            return;
        }
    }
    this.mousemove = this.touchmove = this.bindedMouseMove;
};

EHDI.scene.GameScene.prototype.ontouchmove = function(e){
    if(this.curTouchID != e.data.identifier) return;
    var crop = EHDI.utils.CropUtils.getCropInLoc(this.crops, e.data.global);
    if(crop != null){
        var index = this.selectedCrops.indexOf(crop);
        if(index == -1){
            if(crop.cropState == EHDI.components.CropState.GROWN 
                && ( this.selectedCrops.length == 0 ||
                EHDI.utils.CropUtils.isNeighbors(this.crops, crop, this.selectedCrops[this.selectedCrops.length - 1]))){
                crop.setSelected(true);
                this.selectedCrops.push(crop);
            }
            else{
                //game over
                this.gameOver(crop);
                return;
            }
        }
        else if(index < this.selectedCrops.length - 1){
            var targetSize = index + 1;
            while(targetSize < this.selectedCrops.length){
                this.selectedCrops.pop().setSelected(false);
                //remove selection
            }
        }
    }
    
};

EHDI.scene.GameScene.prototype.ontouchup = function(e){
    if(this.curTouchID != e.data.identifier) return;
    this.curTouchID = null;
    this.mousemove = this.touchmove = null;
    if(this.selectedCrops.length >= 3){
        this.interactive = false;
        var scoreToAdd =(this.selectedCrops.length * 10);
        var atLeastFive = false;
        EHDI.GAME.soundManager.playSFX("plant_harvest");
        if(this.selectedCrops.length >= 5) 
            {
                scoreToAdd += 50;
                EHDI.GAME.soundManager.playSFX("gizmo_positive_0"+Math.ceil(Math.random() * 5));
                atLeastFive = true;
            }

        this.scoreDisplay.addScore(scoreToAdd);
        this.scoreEffects.popScore(e.data.global.x, e.data.global.y, scoreToAdd);

        for(var i = 0, l = this.selectedCrops.length; i < l; i++) {
            this.selectedCrops[i].setSelected(false);
            this.selectedCrops[i].harvestCrop();
            if(atLeastFive)
                this.selectedCrops[i].sparkle();

            this.harvestCount++;
        }
        this.endTurn(true);
    }
    else while(this.selectedCrops.length > 0) this.selectedCrops.pop().setSelected(false);
    
};
EHDI.scene.GameScene.prototype.harvestComplete = function()
{
    this.harvestCount--;

    if(this.harvestCount <= 0)
    {
        this.harvestCount = 0;

        if(this.timeIsUp)
            this.gameOver();
    }
}
EHDI.scene.GameScene.prototype.timerOver = function()
{
    this.timeIsUp = true;

    if(this.harvestCount == 0)
        this.gameOver();

}


EHDI.scene.GameScene.prototype.gameOver = function(crop){

    if(this.isOver)
        return;
    
    this.isOver = true;


    // EHDI.GAME.updateManager.removeFrameListener(this.timer.timerUpdate);
    this.interactive = false;
    if(crop != null){
        this.isCropFailed = true;
        crop.shakeCrop(this.showPostGame.bind(this));
    }
    else this.showPostGame();
};

EHDI.scene.GameScene.prototype.showPostGame = function(){
    this.pauseButton.endGame();
    var score = this.scoreDisplay.getScore();
    var star = 0;
    if(score >= 2000) star = 3;
    else if(score >= 1250) star = 2;
    else if(score >= 500) star = 1;
    this.scoreEffects.hideScores();

    if ( !EHDI.GAME.constants.gameEndFunction ) {
        var goPopup = new EHDI.popup.PostGamePopUp(star, score);
        EHDI.GAME.sceneManager.pushPopUp(goPopup, {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
    }
    else EHDI.GAME.constants.gameEndFunction();
    /* if(score > EHDI.GAME.saveData.highScore) {
        EHDI.GAME.saveData.highScore = score;
        EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
            console.log("data saved.");
        });
    }
    EHDI.sbGame.end(score); */
};

EHDI.scene.GameScene.prototype.cropGlowPause = function()
{
    var cropList = EHDI.utils.CropUtils.combineCrops(this.crops);
    if(!cropList)
        return;

    while(cropList.length > 0)
        {
            var crop = cropList.pop();
            crop.glowPause();
        }
}


EHDI.scene.GameScene.prototype.cropGlowResume = function()
{    
    var cropList = EHDI.utils.CropUtils.combineCrops(this.crops);
    if(!cropList)
        return;

    while(cropList.length > 0)
        {
            var crop = cropList.pop();
            crop.glowResume();
        }
}
